export type MeasurementUnit = "cm" | "in";

export interface MeasurementData {
  bust: number;
  waist: number;
  hip: number;
  shoulder: number;
  sleeveLength: number;
  dressLength: number;
  unit: MeasurementUnit;
}

export interface MeasurementVersion {
  id: string;
  customerId: string;
  data: MeasurementData;
  createdAt: string;
  createdBy: string;
  status: "draft" | "pending_approval" | "accepted" | "rejected";
  notes?: string;
}

export function convertUnit(value: number, from: MeasurementUnit, to: MeasurementUnit): number {
  if (from === to) return value;
  if (from === "cm" && to === "in") return value / 2.54;
  if (from === "in" && to === "cm") return value * 2.54;
  return value;
}

export function formatMeasurement(value: number, unit: MeasurementUnit): string {
  return `${value.toFixed(1)} ${unit}`;
}
